import { useEffect, useState, lazy } from "react";
import Navbar from "../../Component/navbar/Navbar";
import UserNavbar from "../../Component/user/UserNavbar";
import { useSelector } from "react-redux";
import "./style.css";
import "../BusinessCard/style.css";
import "../Guide/style.css";
import "../DigitalMedia/style.css";
import Banner from "../../Component/Banner/Banner";

import {
    qrCodeUses,
} from "./constant";
import {
    dynamicQRData,
    StaticQRData,
    activeMemberDataleft,
    activeMemberDataRight,
} from "../SolutionCard/constant/index";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Flow from "../../Component/Flow/Flow";

const KnowAbout = lazy(() => import("../../Component/KnowAbout/KnowAbout"));
const Footer = lazy(() => import("../../Component/Footer/Footer"));

const SolutionCard = () => {
    const navigate = useNavigate();
    const [showSidebar, setShowSidebar] = useState(false);
    const userState = useSelector((state) => state.user);
    const currentUserId = userState.currentUserId;
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    return (
        <div className="wrapper">
            <Helmet>
                <title>
                    Dynamic QR code generator | Create Your Free QR Codes
                </title>
                <meta
                    name="description"
                    content="Create basic & advanced QR codes in seconds by using QR Code Dynamic, the smart dynamic QR code generator."
                />
                <meta
                    name="keywords"
                    content="Create Dynamic QR codes
                    How to create a dynamic QR code
                    Are you looking to enhance your QR codes?
                    Dynamic QR Code Generator
"
                />
                <meta name="theme-color" content="#008f68" />
                <link
                    rel="canonical"
                    href="https://www.qrcodebrew.com/qr-code-dynamic"
                />
            </Helmet>
            {currentUserId ? (
                <UserNavbar
                    setShowSidebar={setShowSidebar}
                    showSidebar={showSidebar}
                />
            ) : (
                <Navbar />
            )}
            <div className="qrbrew-main solutionCard">
                <section
                    style={
                        currentUserId
                            ? { marginTop: "7vh" }
                            : { marginTop: "1vh" }
                    }
                    className="mobile-mt-0"
                >
                    <Banner
                        Title="Dynamic QR codes"
                        des="Create custom QR codes for free using QRcodebrew. Design the code once, and it will adapt to any changes made in real-time. And edit the scan destination as many times as you want
"
                    />
                </section>

                <section className="section-guide passup-section zero-display">
                    {/* <div>
                        <p
                            className="passupText"
                            style={{ textAlign: "center" }}
                        >
                            Pass Up :{" "}
                        </p>
                    </div> */}

                    <div
                        className="container guide-pt-20"
                        style={{ textAlign: "center" }}
                    >
                        <div className="row">
                            
                            <div className="col">
                                <a href="#whatCan">
                                    <p>
                                        <nobr>What QR Can Do</nobr>
                                    </p>
                                </a>
                            </div>
                            <div className="col">
                                <a href="#dynamic">
                                    <p>
                                        <nobr>Dynamic</nobr>
                                    </p>
                                </a>
                            </div>
                            <div className="col">
                                <a href="#WhyQrCode">
                                    <p>
                                        <nobr>Why</nobr>
                                    </p>
                                </a>
                            </div>
                            <div className="col">
                                <a href="#enhance">
                                    <p>
                                        <nobr>Enhance</nobr>
                                    </p>
                                </a>
                            </div>
                            <div className="col">
                                <a href="#dynamicStatic">
                                    <p>
                                        <nobr>Dynamic & Static</nobr>
                                    </p>
                                </a>
                            </div>

                            {/* <div className='col' style={{  justifyContent:"center" }}>
                  <a href="#activeMember" style={{ width: "237px"}}><p><nobr>Benefits for Active Members</nobr></p></a>
                </div> */}
                            <div className="col">
                                <a href="#faq">
                                    <p>
                                        <nobr>FAQ</nobr>
                                    </p>
                                </a>
                            </div>
                            {/* <div className='col text-center'>
                      <i className="fa-solid fa-briefcase"></i>
                      <p style={{ paddingRight: "0px" }}>Python</p>
                    </div> */}
                        </div>
                    </div>
                </section>

                <div className="container">
                    {/* <h4 className="solutionHeading">Pass up :</h4>
                    <div className="sectionLink">
                        <a href="#whatIs">What is QR</a>
                        <a href="#whatCan">What QR Can Do</a>
                        <a href="#dynamic">Dynamic</a>
                        <a href="#bestQr">Best QR Code</a>
                        <a href="#dynamicStatic">Dynamic & Static</a>
                        <a href="#activeMember">Benefits for Active Member</a>
                        <a href="#faq">FAQ</a>
                    </div> */}

                    {/* first Paragraph */}
                    {/* <section id="whatIs" className="sectionMain row">
                        <div className="col-12 col-lg-6">
                            <h3 className="sectionHeading">
                                Create
                                <span> Dynamic </span> a QR Code?
                            </h3>
                            <p className="sectionText">
                                Create custom QR codes for free using QRcodebrew. Design the code once, and it will adapt to any changes made in real-time. And edit the scan destination as many times as you want.

                            </p>
                        </div>
                        <div className="col-12 col-lg-6 qrImage">
                            <div className="">
                                <div className="qrItem">
                                    <img  loading="lazy"   src={dynamic_QR_code} alt="qrCode" height={300}/>
                                </div>

                            </div>

                        </div>
                    </section> */}
                    {/* second Paragraph */}
                    <section id="whatCan" className="sectionMain row">
                        <div className="col-lg-12">
                            <h3 className="sectionHeading">

                                <span>Update </span>    the destination of your QR code without the need for a reprint.
                            </h3>
                            <p className="sectionText">
                                The <Link className="useAnchorLink" to="/">free qr code generator online</Link> created by QRcodebrew These can be updated in real-time, as they are dynamic. With new information, This allows for greater flexibility and ease of use than traditional static QR codes. Easily change their destinations without recreating them after they have been added to your designs.


                            </p>

                        </div>
                    </section>
                    {/* third Paragraph */}
                    <section id="dynamic" className="sectionMain row">
                        <div className="col-lg-12">

                            <Flow />

                            {qrCodeUses?.map((item, i) => (
                                <div key={item.id} className="useCaseContiner">
                                    <h4>{item?.title}</h4>
                                    <p dangerouslySetInnerHTML={{ __html: item?.heading }}></p>

                                </div>
                            ))}
                        </div>
                    </section>
                    {/* fourth Paragraph */}
                    <section id="dynamicStatic" className="sectionMain row">
                        <div className="col-lg-12">
                            <div className="qrCodeSoultions row">
                                <div
                                    onClick={() => navigate("/")}
                                    className="col-12 col-lg-6 extra"
                                >
                                    <h3>List of Dynamic QR Code solutions</h3>
                                    <div className="qrItemContainer">
                                        {dynamicQRData?.map((item, i) => (
                                            <div
                                                className="singleItem"
                                                key={item?.id}
                                            >
                                                <img  loading="lazy"  
                                                    src={item.image}
                                                    alt={item.title + 1}
                                                    className="Free, Dynamic & Static"
                                                />
                                                <div className="itmeInfo">
                                                    <h6>{item.title}</h6>
                                                    <p>{item.heading}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div
                                    onClick={() => navigate("/")}
                                    className="col-12 col-lg-6"
                                >
                                    <h3 className="extra2">
                                        List of Static QR Code solutions
                                    </h3>
                                    <div className="qrItemContainer">
                                        {StaticQRData?.map((item, i) => (
                                            <div
                                                className="singleItem"
                                                key={item?.id}
                                            >
                                                <img  loading="lazy"  
                                                    src={item.image}
                                                    alt={item.title + 1}
                                                    className="Free, Dynamic & Static "
                                                />
                                                <div className="itmeInfo">
                                                    <h6>{item.title}</h6>
                                                    <p>{item.heading}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* fifth Paragraph */}
                    <section id="WhyQrCode" className="sectionMain row">
                        <div className="col-lg-12">
                            <h3 className="sectionHeading">
                                More Than a <span>Dynamic </span>QR Code Generator
                            </h3>
                            <p className="sectionText">
                                QRcodebrew  QRcodebrew makes  <Link className="useAnchorLink" to="qr-code-solution-card">creating dynamic QR codes</Link> easy while offering additional features to optimise their use.
                            </p>
                        </div>
                    </section>
                    {/* sixth Paragraph */}
                    <section id="activeMember" className="sectionMain row">
                        <div className="col-lg-12">
                            <h3 className="sectionHeading">
                                Do You Prefer Static QR Code or
                                <span> Dynamic </span>QR Code?
                            </h3>
                            <p className="sectionText">
                                A <Link className="useAnchorLink" to="/blogs/dynamic-qr-code-vs.-static-qr-code">static QR code's</Link> function cannot be changed after its creation. This means that the information contained within the code will always be the same. Did you know that dynamic QR codes allow you to modify the information displayed at any time through an app or website dedicated to managing them? Unlike <Link className="useAnchorLink" to="/blogs/dynamic-qr-code-vs.-static-qr-code">static QR codes</Link>, you don't need to create a new code if there are updates related to its content. Instead, you can update the data of your dynamic QR code, which is helpful if you need to make changes or add different links later on. For instance, if you recently updated your restaurant's menu, you can easily edit the link in your QR code using our user-friendly <Link className="useAnchorLink" to="/">free qr code generator online</Link> without creating a new static one with the latest information. It saves you much time since you don't have to repeatedly print and distribute your QR code!
                            </p>
                        </div>
                    </section>
                    {/* seven Paragraph */}
                    <section id="enhance" className="sectionMain row">
                        <div className="col-lg-12">
                            <h3 className="sectionHeading">
                                Are you looking to  <span> Enhance </span> your QR codes?
                            </h3>
                            <p className="sectionText">
                                Our platform offers a range of features, including editable QR codes, scan tracking, and more.
                            </p>
                            <div className="activeItems row">
                                <div className="col-lg-6 leftItem extra3">
                                    {activeMemberDataleft?.map((item, i) => (
                                        <div
                                            className="activeSingleItem"
                                            key={item.id}
                                        >
                                            <img  loading="lazy"  
                                                src={item.image}
                                                alt=""
                                                className="solutions-card-img"
                                            />
                                            <div>
                                                <h3>{item.title}</h3>
                                                <p>{item.desc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-lg-6 leftItem">
                                    {activeMemberDataRight?.map((item, i) => (
                                        <div
                                            className="activeSingleItem"
                                            key={item.id}
                                            onClick={
                                                item.title ===
                                                "Helpful support" &&
                                                (() => navigate("/help"))
                                            }
                                        >
                                            <img  loading="lazy"  
                                                src={item.image}
                                                alt={item.title}
                                                className="solutions-card-img"
                                            />
                                            <div>
                                                <h3>{item.title}</h3>
                                                <p>{item.desc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <hr />
                <div id="faq" className="container">
                    <KnowAbout faq={true} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default SolutionCard;
